import { Route, Routes } from 'react-router';
import CustomViewContainer from 'src/components/commons/customViewContainer';
import NotFoundPage from 'src/components/commons/notFound';

const MessagesRoutes = () => (
  <Routes>
    <Route index element={<CustomViewContainer>messages table</CustomViewContainer>} />
    <Route path='*' element={<NotFoundPage />} />
  </Routes>
);

export default MessagesRoutes;
